import * as React from "react";

export type ChatOutlineBtnProps = {
  children: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  primary?: boolean;
  className?: string;
  "aria-label"?: string;
  type?: "button" | "submit";
};

export const ChatOutlineBtn: React.FC<ChatOutlineBtnProps> = ({
  children,
  onClick,
  disabled,
  primary,
  className,
  "aria-label": ariaLabel,
  type = "button",
}) => (
  <button
    type={type}
    className={`chat-outline-btn${primary ? " chat-outline-btn--primary" : ""}${className ? ` ${className}` : ""}`}
    onClick={onClick}
    disabled={disabled}
    aria-label={ariaLabel}
  >
    {children}
  </button>
);
